import QueryTransaction from "graphql/queries/QueryTransaction";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder';

const FetchTransaction = {
	
	fetch: ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'transaction', QueryTransaction, {
			variables: variables,
			resultPath: [ 'transaction' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchTransaction
